import {
  Observer,
  UserRole,
  UsersResponse,
  convertObserver,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { compareUsersByName } from 'management_team/util'
import { convertUserRoleToQueryParam } from './shared/convert'
import keys from './shared/keys'

export function useUserList(
  companyId: string | undefined,
  role: UserRole | undefined
) {
  const { server } = useServer()
  return useQuery<Observer[]>({
    queryKey: keys.list(companyId, role),
    queryFn: fetchUserList,
    enabled: !!companyId && !!role,
  })

  async function fetchUserList() {
    const response = await server.get<UsersResponse.ObserverList>(
      getUrl(companyId, role)
    )
    return response?.users.map(convertObserver).sort(compareUsersByName)
  }
}

function getUrl(companyId: string | undefined, role: UserRole | undefined) {
  if (!companyId) {
    throw new Error('Company id invalid')
  }

  const roleParam = convertUserRoleToQueryParam(role)

  if (!roleParam) {
    throw new Error('Role invalid')
  }

  return `/v2/users/role/${companyId}?role_name=${roleParam}`
}
